import { useContext } from 'react';
import { ApprovalContext } from '../context/approvalContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const withApprovalContext = WrappedComponent => {
  const WithApprovalContext = props => {
    const approval = useContext(ApprovalContext);
    if (!approval) {
      return null;
    }
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      approval: approval
    }));
  };
  return WithApprovalContext;
};